import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { cardsService } from "./cardsService";

export const createCard = async (
  request: cardApiSpec.CreateCardRequest
): Promise<cardApiSpec.Card> => {
  const { data } = await cardsService.post("", request);

  return data;
};
